import React from "react";
import { ThemedLayoutV2 } from "@refinedev/antd";
import styles from "./layout.module.css";

type ModernLayoutProps = React.ComponentProps<typeof ThemedLayoutV2>;

export const ModernLayout: React.FC<ModernLayoutProps> = (props) => {
  return (
    <div className={styles.layoutWrapper}>
      {/* Camada 1: Canvas base limpo */}
      <div className={styles.bgLayer1} />

      {/* Camada 2: Brilho azul muito sutil no topo */}
      <div className={styles.bgLayer2} />

      {/* Conteúdo */}
      <div className={styles.contentWrapper}>
        <ThemedLayoutV2 {...props} />
      </div>
    </div>
  );
};

